/**
 * @generated SignedSource<<c7fa41d54b6e4d2fb9e3df820fc36d20>>
 * @relayHash 8c39d3f92a66bdbee539985ab474df88
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8c39d3f92a66bdbee539985ab474df88

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PortfolioProjectTextCoverStyle = "COLOR_BLACK" | "COLOR_BLUE" | "COLOR_GREEN" | "COLOR_ORANGE" | "COLOR_PURPLE" | "COLOR_SALMON" | "COLOR_WATERMELON" | "COLOR_WHITE" | "COLOR_YELLOW" | "SHAPE_COINS_DARK" | "SHAPE_COINS_LIGHT" | "SHAPE_COLLABORATION_DARK" | "SHAPE_COLLABORATION_LIGHT" | "SHAPE_FOCUS_DARK" | "SHAPE_FOCUS_LIGHT" | "SHAPE_GAIN_DARK" | "SHAPE_GAIN_LIGHT" | "SHAPE_STAIRS_DARK" | "SHAPE_STAIRS_LIGHT" | "SHAPE_WAVE_DARK" | "SHAPE_WAVE_LIGHT" | "SVG_BLUE" | "SVG_BLUE2" | "SVG_LINES_BLUE" | "SVG_LINES_GREEN" | "SVG_LINES_ORANGE" | "SVG_LINES_PURPLE" | "SVG_LINES_SALMON" | "SVG_LINES_YELLOW" | "SVG_WHITE" | "SVG_WHITE2" | "SVG_YELLOW" | "SVG_YELLOW2" | "VAPOR_GRADIENT_BLUE_DARK" | "VAPOR_GRADIENT_BLUE_LIGHT" | "VAPOR_GRADIENT_GREEN_DARK" | "VAPOR_GRADIENT_GREEN_LIGHT" | "VAPOR_GRADIENT_PURPLE_DARK" | "VAPOR_GRADIENT_PURPLE_LIGHT" | "VAPOR_GRADIENT_SALMON_DARK" | "VAPOR_GRADIENT_SALMON_LIGHT" | "VAPOR_GRADIENT_WATERMELON_DARK" | "VAPOR_GRADIENT_WATERMELON_LIGHT" | "VAPOR_GRADIENT_WHITE_DARK" | "VAPOR_GRADIENT_YELLOW_LIGHT" | "%future added value";
export type ProductizedServiceDurationInterval = "DAY" | "WEEK" | "%future added value";
export type ProductizedServicePriceInterval = "DAY" | "HOUR" | "MONTH" | "WEEK" | "%future added value";
export type ProductizedServicePriceType = "CONTACT_FOR_PRICING" | "FIXED_PRICE" | "RATE" | "%future added value";
export type ProductizedServiceType = "BUY_NOW_INSTANT_PURCHASE" | "BUY_NOW_OTHER" | "BUY_NOW_REQUEST" | "NOT_PURCHASABLE" | "%future added value";
export type UpdateProductizedServiceInput = {
  blocknoteContent?: ContraAPIScalars.JSON | null;
  blocknotePostPurchaseDetails?: ContraAPIScalars.JSON | null;
  blocknoteProcessDescription?: ContraAPIScalars.JSON | null;
  calendarLink?: string | null;
  collaborators?: ProductizedServiceCollaboratorsInput | null;
  coverImage?: UploadedImageInput | null;
  coverStyle?: PortfolioProjectTextCoverStyle | null;
  deliverables?: ReadonlyArray<ProductizedServiceDeliverableInput> | null;
  duration?: ProductizedServiceDurationInput | null;
  faqs?: ReadonlyArray<ProductizedServiceFAQInput> | null;
  id: string;
  industryCategories?: ReadonlyArray<string> | null;
  introductionVideo?: ProductizedServiceIntroductionVideoInput | null;
  outcomeId?: string | null;
  portfolioProjects?: ReadonlyArray<string> | null;
  price?: ProductizedServicePriceInput | null;
  productizedServiceType?: ProductizedServiceType | null;
  publishedAt?: ContraAPIScalars.DateTime | null;
  rolesAndTools?: RolesAndToolsInput | null;
  slateContent?: ContraAPIScalars.JSON | null;
  slatePostPurchaseDetails?: ContraAPIScalars.JSON | null;
  slateProcessDescription?: ContraAPIScalars.JSON | null;
  slateRequirementsDescription?: ContraAPIScalars.JSON | null;
  title?: string | null;
};
export type ProductizedServiceCollaboratorsInput = {
  associate: ReadonlyArray<AssociateProductizedServiceCollaboratorInput>;
  create: ReadonlyArray<CreateProductizedServiceCollaboratorInput>;
};
export type AssociateProductizedServiceCollaboratorInput = {
  id: string;
  personalMessage?: string | null;
};
export type CreateProductizedServiceCollaboratorInput = {
  emailAddress: string;
  name: string;
  personalMessage?: string | null;
};
export type UploadedImageInput = {
  animated: boolean;
  checksum?: string | null;
  height: number;
  originalFormat: string;
  resourceType?: string | null;
  sizeBytes: number;
  uid: string;
  width: number;
};
export type ProductizedServiceDeliverableInput = {
  description: string;
  title: string;
};
export type ProductizedServiceDurationInput = {
  amount: number;
  interval: ProductizedServiceDurationInterval;
};
export type ProductizedServiceFAQInput = {
  answer: string;
  question: string;
};
export type ProductizedServiceIntroductionVideoInput = {
  displayLabel?: string | null;
  isEnabled?: boolean | null;
  video?: UploadedVideoInputV2 | null;
};
export type UploadedVideoInputV2 = {
  audioCodecName?: string | null;
  checksum?: string | null;
  duration: number;
  height: number;
  originalFormat: string;
  sizeBytes: number;
  uid: string;
  videoCodecName?: string | null;
  width: number;
};
export type ProductizedServicePriceInput = {
  amount?: number | null;
  interval?: ProductizedServicePriceInterval | null;
  timeline?: string | null;
  type: ProductizedServicePriceType;
};
export type RolesAndToolsInput = {
  roles: ReadonlyArray<RoleInput>;
  tools: ReadonlyArray<ToolInput>;
};
export type RoleInput = {
  name: string;
};
export type ToolInput = {
  name: string;
};
export type ServicePageShowImageUpdateProductizedServiceMutation$variables = {
  input: UpdateProductizedServiceInput;
};
export type ServicePageShowImageUpdateProductizedServiceMutation$data = {
  readonly updateProductizedService: {
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message: string;
    }> | null;
    readonly productizedService: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ServicePageShowImage_productizedService">;
    } | null;
  };
};
export type ServicePageShowImageUpdateProductizedServiceMutation = {
  response: ServicePageShowImageUpdateProductizedServiceMutation$data;
  variables: ServicePageShowImageUpdateProductizedServiceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ServicePageShowImageUpdateProductizedServiceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateProductizedServicePayload",
        "kind": "LinkedField",
        "name": "updateProductizedService",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductizedService",
            "kind": "LinkedField",
            "name": "productizedService",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ServicePageShowImage_productizedService"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ServicePageShowImageUpdateProductizedServiceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateProductizedServicePayload",
        "kind": "LinkedField",
        "name": "updateProductizedService",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "CollaboratorNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "CollaboratorRoleCountInvalidError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "OrganizationNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "ProductizedServiceCollaboratorNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "ReferBasicOpportunityUserNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "SubmitJoinOrganizationRequestError",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductizedService",
            "kind": "LinkedField",
            "name": "productizedService",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": "productizedServiceId",
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "visitorCanEdit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "publishedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "cover",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isPortfolioProjectCover"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContraImage",
                        "kind": "LinkedField",
                        "name": "image",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "animated",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "uid",
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "PortfolioProjectImageCover",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "style",
                        "storageKey": null
                      }
                    ],
                    "type": "PortfolioProjectTextCover",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "8c39d3f92a66bdbee539985ab474df88",
    "metadata": {},
    "name": "ServicePageShowImageUpdateProductizedServiceMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "6761c506e7a4565dfa5a7e1d1819fcd0";

export default node;
